"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../api/api");
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _default = exports.default = {
  name: 'side-nav',
  props: ['side_bind'],
  data: function data() {
    return {
      QRcodeObj: {},
      //查询的二维码信息
      jForm: {
        businessName: '',
        businessCellphone: '',
        businessCompany: '',
        businessCity: '',
        businessCityId: 0,
        businessType: this.businessType,
        // 商业合作类型(10:招投标,20:WMS,30:TMS)
        generalizeUserId: '',
        //推广人id
        generalizeSource: '10' //来源,PC:10,wap:20
      },
      city: [],
      citys: _appCitysData.default.cityDataWithoutDistrict,
      //出发城市数据
      unSupportCitysArr: ['台湾', '香港特别行政区', '澳门特别行政区', '钓鱼岛'],
      disabled: true,
      overlayVisible: false,
      bindId: '#' + this.side_bind,
      initQCode: 'http://www.weihuabiaoju.com/appDownload.dhtml?ncrypt=()(c)L33E/NY32aX1VkUU366w==',
      imageSrc: require("../../src/assets/static/img/sidenav/phone.png"),
      imageSrcOnline: require("../../src/assets/static/img/sidenav/Online.png"),
      imageback: require("../../src/assets/static/img/sidenav/back.png"),
      Ip: "",
      Ipobj: {},
      options: [{
        value: '10',
        label: '找车'
      }, {
        value: '20',
        label: '找货'
      }],
      value: '10'
    };
  },
  mounted: function mounted() {
    // this.goAnchor(this.bindId)
    // 调用接口获取ip地址
    // this.get("http://ip-api.com/json/", (data) => {
    //     console.log('这是啥')
    //     data = JSON.parse(data);
    //     this.Ip = data.ip;
    //     if (this.Ip) {
    //         this.getIP(this.Ip)
    //     }
    // });
    this.getIP('');
  },
  methods: {
    getIP: function () {
      var _getIP = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var param, _yield$apigetiplocate, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              param = {
                ip: value
              };
              _context.next = 3;
              return (0, _api.apigetiplocate)(param);
            case 3:
              _yield$apigetiplocate = _context.sent;
              data = _yield$apigetiplocate.data;
              if (data.proCode == '200') {
                this.Ipobj = data.proData;
                // console.log(this.Ipobj, '获取ip')
                this.setCityFromLocation();
              } else {
                console.log(this.Ipobj, '失败');
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getIP(_x) {
        return _getIP.apply(this, arguments);
      }
      return getIP;
    }(),
    setCityFromLocation: function setCityFromLocation() {
      // console.log('获取i111p')
      var locationParts = this.Ipobj.location.split('/'); // ["福建省", "厦门市"]
      var provinceName = locationParts[0];
      var cityName = locationParts[1];
      var provinceValue = '';
      var cityValue = '';
      // 找到省份
      var province = this.citys.find(function (prov) {
        return prov.label === provinceName;
      });
      if (province) {
        // console.log(province, "provinceprovinceprovince")
        provinceValue = province.label;
        this.jForm.businessCityId = province.value;
        // 找到市
        var city = province.children.find(function (city) {
          return city.label === cityName;
        });
        if (city) {
          cityValue = city.label;
          this.jForm.businessCityId = city.value;
        }
      }
      // 将找到的 value 赋值到 this.city
      if (provinceValue && cityValue) {
        this.city = [provinceValue, cityValue];
        this.getData();
      }
    },
    // 获取ip地址
    get: function get(url, cb) {
      var httpRequest = new XMLHttpRequest();
      httpRequest.open("GET", url, true);
      httpRequest.send();
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState == 4 && httpRequest.status == 200) {
          var json = httpRequest.responseText;
          cb(json);
        }
      };
    },
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var param, _yield$apigetWechatCu, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              param = {
                locationId: this.jForm.businessCityId ? this.jForm.businessCityId : '',
                //发车/货 的出发地id。其他地方默认用户号码归属地
                serviceType: this.value //10找车 20找货 不传默认分端配置为车主端找货20，货主端10
              };
              _context2.next = 3;
              return (0, _api.apigetWechatCustomerService)(param);
            case 3:
              _yield$apigetWechatCu = _context2.sent;
              data = _yield$apigetWechatCu.data;
              if (data.proCode == '200') {
                this.QRcodeObj = data.proData;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    //选择到达城市
    cityChange: function cityChange(value) {
      var that = this;
      if (value.length > 0 && this.unSupportCitysArr.includes(value[0])) {
        value = [];
        that.city = [];
        that.cityId = 0;
        that.jForm.businessCity = '';
        that.jForm.businessCityId = 0;
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        return;
      } else if (value.length > 0 && !this.unSupportCitysArr.includes(value[0])) {
        that.jForm.businessCity = value.join('/').replace(/\/全省/g, '').replace(/\/全市/g, '');
        that.city = value;
        that.getCityId(this.citys, value, 0);
        that.getData();
      }
      console.log(this.city, '  this.city  this.city');
    },
    //选择类型
    typeChange: function typeChange(value) {
      // console.log(value, 'valuevaluevaluey')
      this.value = value;
      this.getData();
    },
    // 获取城市id
    getCityId: function getCityId(citys, arr, n) {
      var _this = this;
      citys.filter(function (item) {
        if (item.label == arr[n]) {
          if (item.children) {
            n++;
            return _this.getCityId(item.children, arr, n);
          } else {
            _this.jForm.businessCityId = item.value;
            _this.cityId = item.value;
          }
        }
      });
    },
    showOverlay: function showOverlay() {
      this.overlayVisible = true;
    },
    closeOverlay: function closeOverlay() {
      this.overlayVisible = false;
    },
    jumpOnline: function jumpOnline() {
      // window.location.href = 'https://work.weixin.qq.com/kfid/kfc39dbc89785a0a704'
      window.open('https://work.weixin.qq.com/kfid/kfc39dbc89785a0a704', '_blank', 'width=500,height=700');
    },
    jumpAdd: function jumpAdd() {
      this.overlayVisible = true;
      this.getData();
    },
    changeImageback: function changeImageback(isHovered) {
      this.imageback = isHovered ? require("../../src/assets/static/img/sidenav/backBlue.png") : require("../../src/assets/static/img/sidenav/back.png");
    },
    changeImage: function changeImage(isHovered) {
      this.imageSrc = isHovered ? require("../../src/assets/static/img/sidenav/phoneBlue.png") : require("../../src/assets/static/img/sidenav/phone.png");
    },
    changeImageOnline: function changeImageOnline(isHovered) {
      this.imageSrcOnline = isHovered ? require("../../src/assets/static/img/sidenav/Onlineblue.png") : require("../../src/assets/static/img/sidenav/Online.png");
    },
    goAnchor: function goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        // 平滑过渡
        block: "start" // 上边框与视窗顶部平齐。默认值
      });
    }
  }
};